import { defineMessages } from "react-intl";

import {
	papanicolaouMessages,
	resultMessages,
	validator
} from "lib/build/forms/ltx/phase-i/consultations/gynecology";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	gynecology: {
		id: "form.gynecology",
		defaultMessage: "Nőgyógyászati szakvizsgálat"
	},
	result: {
		id: "form.gynecology.result",
		defaultMessage: "Eltérés"
	},
	papanicolaou: {
		id: "form.gynecology.papanicolaou",
		defaultMessage: "Méhnyakrák szűrés történt"
	}
});

const fields: { [key: string]: FieldData } = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: resultMessages } }
	},
	papanicolaou: {
		type: "field",
		path: ["papanicolaou"],
		label: messages.papanicolaou,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: papanicolaouMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.result }] },
		{ columns: [{ width: 12, field: fields.papanicolaou }] }
	]
};

export const node: LeafNode = {
	id: "gynecology",
	value: {
		title: messages.gynecology,
		validator,
		fieldset
	}
};
